export const documentsEn = {
  //BEGIN Michael
  DOCUMENT: 'Document',
  DOCUMENTS: 'Documents',
  DOCUMENT_TYPE: 'Document Type',
  OTHER: 'Other',
  EXPIRATION_DATE: 'Expiration Date',
  INFO_ALL_DOCS_SAME: 'All the files will be uploaded with the same document type and expiration date.',
  OTHER_FUNCTION_LINKED: 'This document type is linked to other functions.',
  NOA_WARNING:
    'A client can only have one NOA active at any given time. If you upload a new NOA document, the previous documents will be deactivated. If you upload more than one document with the NOA Type, only the last document will be kept active.',
  ONLY_PDF: 'Only PDF files are allowed.',
  DOCUMENT_TYPE_NOT_ALLOWED: 'File type not allowed. Allowed types: PDF, images and Excel.',
  ARCHIVED: 'Archived',
  ARCHIVED_DOCUMENT: 'Archived Document',
  ARCHIVED_DOCUMENTS: 'Archived Documents',
  PREVIEW_DOCUMENT: 'Preview Document',
  DOCUMENTS_PREVIEW: 'Documents Preview',
  NO_DOCUMENTS_TOOLTIP: 'No documents',
  NO_DOCUMENTS: 'No documents to preview.',
  UNSUPPORTED_DOCUMENTS_NOTICE:
    'This invoice has {count} document(s) in an unsupported format — they cannot be previewed yet.',
  DOCUMENT_LOAD_ERROR: 'This document could not be loaded.',
  DOCUMENT_LOAD_ERRORS_NOTICE: '{count} document(s) could not be loaded: {names}',
  DOCUMENTS_LOAD_ERROR: 'The invoice documents could not be loaded. Please try again.',
  ZOOM_IN: 'Zoom in',
  ZOOM_OUT: 'Zoom out',
  PREVIEW_NOT_AVAILABLE: 'Preview is not available for this file. Please download it instead.',
  PREVIEW_FILE_TOO_LARGE: 'This file is too large to preview or render. We recommend downloading it to view it.',
  PREVIEW_ROWS_TRUNCATED: 'Preview limited to the first {shown} of {total} rows.',
  PREVIEW_COLUMNS_TRUNCATED: 'Preview limited to the first {shown} of {total} columns.',
  PREVIEW_SHEETS_TRUNCATED: '{omitted} more worksheet(s) are in the downloaded file.',
  PREVIEW_DOWNLOAD_COMPLETE_FILE: 'Download the file to view everything.',
  PREVIEW_WORKBOOK_SHEETS: 'Workbook sheets',
  PREVIEW_EMPTY_WORKBOOK: 'This workbook does not contain any worksheets.',
  DOWNLOAD_DOCUMENT: 'Download Document',
  OPEN_IN_NEW_TAB: 'Open in new tab',
  NOT_PREVIEWABLE: 'Not previewable',
  FIT_WIDTH: 'Fit width',
  DOCUMENT_POSITION: 'Document {current} of {total}',
  DOCUMENT_COUNT: '{count} document(s)',
  PAGE_COUNT: '{count} page(s)',
  NO_DOCUMENTS_ATTACHED: 'No documents attached.',
  NO_DOCUMENTS_ATTACHED_TITLE: 'No documents attached to this invoice',
  NO_DOCUMENTS_ATTACHED_BODY: 'Upload or request documents to preview them here.',
  PREVIEW_NOT_AVAILABLE_TITLE: 'Preview not available for this file type',
  PREVIEW_NOT_AVAILABLE_BODY: "This file can't be rendered yet — open it in a new tab to view the contents.",
  FILTER_BY_TYPE: 'Filter by type',
  PREVIOUS_INVOICE: 'Previous invoice',
  NEXT_INVOICE: 'Next invoice',
  INVOICE_POSITION: 'Invoice {current} of {total}',
  EDIT_DOCUMENT: 'Edit Document',
  DOCUMENT_UPDATED_SUCCESSFULLY: 'Document updated successfully!',
  NOA_UPDATE_WARNING:
    'A client can only have one NOA active at any given time. Updating this document to NOA will deactivate any other active NOA document for this client.',
  //END Michael
  //BEGIN Fco
  FILE_SIZE: 'File Size',
  DOWNLOAD_URL: 'Download URL',
  DRAG_AND_DROP: 'Drag and drop files or click upload',
  DROP_HERE: 'Drop the files here!',
  UPLOAD_FILES: 'Upload Files',
  SUBMIT_FILES: 'Submit Files',
  UPLOAD_WARNING: 'Do not close the screen while the files are being uploaded.',
  ONLY_PDF_FILES: 'Only PDF files.',
  ALL_TYPE_ALLOWDED: 'PDF, PNG and JPG',
  INVOICE_DOC_TYPES: 'PDF, images and Excel',
  //END Fco
  //BEGIN Fabian
  DRAG_AND_DROP_SINGLE: 'Drag & drop a file here, or click to select a file.',
  //END Fabian
  //BEGIN Elias
  INFO_MAX_FILE_SIZE: "Attachments can't exceed {limit} total.",
  ERROR_FILE_SIZE_EXCEEDED_TITLE: 'Attachments size limit exceeded',
  ERROR_FILE_SIZE_EXCEEDED:
    'This upload would exceed the {limit} limit. Please remove or compress a file and try again.',
  ERROR_FILE_SIZE_EXCEEDED_WITH_NOA:
    'This upload would exceed the {limit} limit. The total includes the NOA document ({noaSize}), which is added automatically. Please remove or compress a file and try again.',
  //END Elias
  // START patricio
  ONLY_CSV_FILE_RESTRICTION: 'CSV File (Import limit: 5,000 rows per file, one file at a time.)',
  // END patricio
  // START FC2-3844
  NOA_RELATION_DOCUMENT: 'NOA Document (Relation)',
  NOA_RELATION_UPLOAD_HINT: 'Upload a NOA specific to this relationship. It takes priority over the client-level NOA.',
  NOA_RELATION_REMOVED: 'NOA document removed from this relationship.',
  NOA_RELATION_UPLOADED: 'NOA document attached to this relationship.',
  NOA_RELATION_REMOVE: 'Remove NOA',
  // END FC2-3844
  MERGE_FILES: 'Merge & Download',
  MERGE_AND_SEND: 'Merge & Send',
  INVOICE_EXPORT_EMAIL_SENT_SUCCESS: 'Merged documents sent successfully',
  ERROR_INVOICE_EXPORT: 'Failed to send merged documents. Please try again.',
  EMAILS_TO_SEND_DOCUMENTS: 'Emails to send documents',
  BILLING_CLASSIFICATION: 'Billing Classification',
  INVOICE_BILLING: 'Billing',
  INVOICE_NON_BILLING: 'Invoice Non Billing',
  BILLING_CLASSIFICATION_HINT:
    'Documents with the “Invoice Non Billing” type are stored internally and excluded from the documentation sent to the debtor.',
  CREATE_INVOICE_BILLING_DEFAULT_INFO:
    'Documents uploaded here default to Invoice. You can change the type in the Documents tab after creation.',
  // START FC2-4178
  INVOICE_DOCUMENTS_SIZE_TOOLTIP: 'Invoice documents: {size}',
  NOA_DOCUMENT_SIZE_TOOLTIP: 'NOA document: {size}',
  // END FC2-4178
}

export const documentsEs: typeof documentsEn = {
  //BEGIN Michael
  DOCUMENT: 'Documento',
  DOCUMENTS: 'Documentos',
  DOCUMENT_TYPE: 'Tipo de Documento',
  OTHER: 'Otro',
  EXPIRATION_DATE: 'Fecha de Expiración',
  INFO_ALL_DOCS_SAME: 'Todos los archivos serán subidos con el mismo Tipo de Documento y Fecha de Expiración.',
  OTHER_FUNCTION_LINKED: 'Este tipo de documento está vinculado a otras funciones.',
  ONLY_PDF: 'Solo se permiten archivos PDF.',
  DOCUMENT_TYPE_NOT_ALLOWED: 'Tipo de archivo no permitido. Permitidos: PDF, imágenes y Excel.',
  ONLY_PDF_FILES: 'Sólo archivos PDF.',
  ALL_TYPE_ALLOWDED: 'PDF, PNG y JPG',
  INVOICE_DOC_TYPES: 'PDF, imágenes y Excel',
  NOA_WARNING:
    'Un Cliente solo puede tener un documento NOA activo a la vez. Si subes un nuevo documento NOA, los anteriores serán desactivados. Si subes más de un documento con el Tipo NOA, solo el último documento se mantendrá activo.',
  ARCHIVED: 'Archivado',
  ARCHIVED_DOCUMENT: 'Documento Archivado',
  ARCHIVED_DOCUMENTS: 'Documentos Archivados',
  PREVIEW_DOCUMENT: 'Vista Previa del Documento',
  DOCUMENTS_PREVIEW: 'Vista Previa de Documentos',
  NO_DOCUMENTS_TOOLTIP: 'Sin documentos',
  NO_DOCUMENTS: 'No hay documentos para previsualizar.',
  UNSUPPORTED_DOCUMENTS_NOTICE:
    'El invoice tiene {count} documento(s) con formato no soportado — por ahora no se pueden previsualizar.',
  DOCUMENT_LOAD_ERROR: 'Este documento no pudo cargarse.',
  DOCUMENT_LOAD_ERRORS_NOTICE: '{count} documento(s) no pudieron cargarse: {names}',
  DOCUMENTS_LOAD_ERROR: 'No se pudieron cargar los documentos del invoice. Inténtalo de nuevo.',
  ZOOM_IN: 'Acercar',
  ZOOM_OUT: 'Alejar',
  PREVIEW_NOT_AVAILABLE: 'La vista previa no está disponible para este archivo. Descárgalo para verlo.',
  PREVIEW_FILE_TOO_LARGE:
    'El archivo es muy grande para mostrarlo o renderizarlo. Te recomendamos descargarlo para visualizarlo.',
  PREVIEW_ROWS_TRUNCATED: 'Vista previa limitada a las primeras {shown} de {total} filas.',
  PREVIEW_COLUMNS_TRUNCATED: 'Vista previa limitada a las primeras {shown} de {total} columnas.',
  PREVIEW_SHEETS_TRUNCATED: 'Hay {omitted} hoja(s) más en el archivo descargado.',
  PREVIEW_DOWNLOAD_COMPLETE_FILE: 'Descarga el archivo para ver todo.',
  PREVIEW_WORKBOOK_SHEETS: 'Hojas del libro',
  PREVIEW_EMPTY_WORKBOOK: 'Este libro no contiene hojas.',
  DOWNLOAD_DOCUMENT: 'Descargar Documento',
  OPEN_IN_NEW_TAB: 'Abrir en pestaña nueva',
  NOT_PREVIEWABLE: 'No previsualizable',
  FIT_WIDTH: 'Ajustar al ancho',
  DOCUMENT_POSITION: 'Documento {current} de {total}',
  DOCUMENT_COUNT: '{count} documento(s)',
  PAGE_COUNT: '{count} página(s)',
  NO_DOCUMENTS_ATTACHED: 'No hay documentos adjuntos.',
  NO_DOCUMENTS_ATTACHED_TITLE: 'No hay documentos adjuntos a este invoice',
  NO_DOCUMENTS_ATTACHED_BODY: 'Carga o solicita documentos para previsualizarlos aquí.',
  PREVIEW_NOT_AVAILABLE_TITLE: 'Vista previa no disponible para este tipo de archivo',
  PREVIEW_NOT_AVAILABLE_BODY:
    'Este archivo aún no se puede renderizar — abrilo en una pestaña nueva para ver el contenido.',
  FILTER_BY_TYPE: 'Filtrar por tipo',
  PREVIOUS_INVOICE: 'Invoice anterior',
  NEXT_INVOICE: 'Invoice siguiente',
  INVOICE_POSITION: 'Invoice {current} de {total}',
  EDIT_DOCUMENT: 'Editar Documento',
  DOCUMENT_UPDATED_SUCCESSFULLY: '¡Documento actualizado exitosamente!',
  NOA_UPDATE_WARNING:
    'Un Cliente solo puede tener un documento NOA activo a la vez. Actualizar este documento a NOA desactivará cualquier otro documento NOA activo para este cliente.',
  //END Michael
  //BEGIN Fco
  FILE_SIZE: 'Tamaño de Archivo',
  DOWNLOAD_URL: 'URL de Descarga',
  DRAG_AND_DROP: 'Arrastra uno o más archivos aquí, o haz click para seleccionar archivos.',
  DROP_HERE: '¡Suelta los archivos aquí!',
  UPLOAD_FILES: 'Subir Archivos',
  SUBMIT_FILES: 'Enviar Archivos',
  UPLOAD_WARNING: 'No cierres esta ventana mientras los archivos se están subiendo.',
  //END Fco
  //BEGIN Fabian
  DRAG_AND_DROP_SINGLE: 'Arrastra un archivo aquí, o haz click para seleccionar un archivo.',
  //END Fabian
  //BEGIN Elias
  INFO_MAX_FILE_SIZE: 'Los archivos adjuntos no pueden exceder {limit} en total.',
  ERROR_FILE_SIZE_EXCEEDED_TITLE: 'Tamaño de adjuntos excedido',
  ERROR_FILE_SIZE_EXCEEDED:
    'Esta carga superaría el límite de {limit}. Elimina o comprime un archivo e inténtalo de nuevo.',
  ERROR_FILE_SIZE_EXCEEDED_WITH_NOA:
    'Esta carga superaría el límite de {limit}. El total incluye el documento NOA ({noaSize}), que se agrega automáticamente. Elimina o comprime un archivo e inténtalo de nuevo.',
  //END Elias
  // START patricio
  ONLY_CSV_FILE_RESTRICTION: 'Archivo CSV (Límite de importación: 5,000 filas por archivo, un archivo a la vez.)',
  // END patricio
  // START FC2-3844
  NOA_RELATION_DOCUMENT: 'Documento NOA (Relación)',
  NOA_RELATION_UPLOAD_HINT:
    'Sube un NOA específico para esta relación. Tiene prioridad sobre el NOA a nivel de cliente.',
  NOA_RELATION_REMOVED: 'Documento NOA eliminado de esta relación.',
  NOA_RELATION_UPLOADED: 'Documento NOA adjuntado a esta relación.',
  NOA_RELATION_REMOVE: 'Eliminar NOA',
  // END FC2-3844
  MERGE_FILES: 'Combinar y Descargar',
  MERGE_AND_SEND: 'Combinar y Enviar',
  INVOICE_EXPORT_EMAIL_SENT_SUCCESS: 'Documentos combinados enviados exitosamente',
  ERROR_INVOICE_EXPORT: 'Error al enviar los documentos combinados. Por favor, inténtelo de nuevo.',
  EMAILS_TO_SEND_DOCUMENTS: 'Correos electrónicos para enviar documentos',
  BILLING_CLASSIFICATION: 'Clasificación de Facturación',
  INVOICE_BILLING: 'Facturable',
  INVOICE_NON_BILLING: 'Invoice Non Billing',
  BILLING_CLASSIFICATION_HINT:
    'Los documentos con el tipo “Invoice Non Billing” se almacenan internamente y se excluyen de la documentación enviada al deudor.',
  CREATE_INVOICE_BILLING_DEFAULT_INFO:
    'Los documentos subidos aquí se clasifican como Invoice por defecto. Puedes cambiar el tipo en la pestaña de Documentos después de crear la factura.',
  // START FC2-4178
  INVOICE_DOCUMENTS_SIZE_TOOLTIP: 'Documentos del invoice: {size}',
  NOA_DOCUMENT_SIZE_TOOLTIP: 'Documento NOA: {size}',
  // END FC2-4178
}
